import _classCallCheck from "/home/vsts/work/1/s/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/vsts/work/1/s/node_modules/@babel/runtime/helpers/esm/createClass";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
import { ArgumentNullError, createNoDashGuid } from "../common/Exports";
import { WebsocketMessageAdapter } from "./WebsocketMessageAdapter";
export var WebsocketConnection = /*#__PURE__*/function () {
  function WebsocketConnection(uri, queryParameters, headers, messageFormatter, proxyInfo, connectionId) {
    var _this = this;

    _classCallCheck(this, WebsocketConnection);

    this.privIsDisposed = false;

    this.dispose = function () {
      _this.privIsDisposed = true;

      if (_this.privConnectionMessageAdapter) {
        _this.privConnectionMessageAdapter.close();
      }
    };

    this.isDisposed = function () {
      return _this.privIsDisposed;
    };

    this.state = function () {
      return _this.privConnectionMessageAdapter.state;
    };

    this.open = function () {
      return _this.privConnectionMessageAdapter.open();
    };

    this.send = function (message) {
      return _this.privConnectionMessageAdapter.send(message);
    };

    this.read = function () {
      return _this.privConnectionMessageAdapter.read();
    };

    if (!uri) {
      throw new ArgumentNullError("uri");
    }

    if (!messageFormatter) {
      throw new ArgumentNullError("messageFormatter");
    }

    this.privMessageFormatter = messageFormatter;
    var queryParams = "";
    var i = 0;

    if (queryParameters) {
      for (var paramName in queryParameters) {
        if (paramName) {
          queryParams += i === 0 && uri.indexOf("?") === -1 ? "?" : "&";
          var val = encodeURIComponent(queryParameters[paramName]);
          queryParams += "".concat(paramName, "=").concat(val);
          i++;
        }
      }
    }

    if (headers) {
      for (var headerName in headers) {
        if (headerName) {
          queryParams += i === 0 ? "?" : "&";

          var _val = encodeURIComponent(headers[headerName]);

          queryParams += "".concat(headerName, "=").concat(_val);
          i++;
        }
      }
    }

    this.privUri = uri + queryParams;
    this.privId = connectionId ? connectionId : createNoDashGuid();
    this.privConnectionMessageAdapter = new WebsocketMessageAdapter(this.privUri, this.id, this.privMessageFormatter, proxyInfo, headers);
  }

  _createClass(WebsocketConnection, [{
    key: "id",
    get: function get() {
      return this.privId;
    }
  }, {
    key: "events",
    get: function get() {
      return this.privConnectionMessageAdapter.events;
    }
  }]);

  return WebsocketConnection;
}();